import { useMutation } from "@tanstack/react-query";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function deleteUnkownTransactionRequest(mappingsToDelete: string[]) {
	return await apiClient
		.post(API.COMMAND.ADMIN.DELETE_UNKOWN_TRANSACTIONS(), mappingsToDelete)
		.then((res) => res.data);
}

export function useDeleteUnknownTransactions() {
	return useMutation({
		mutationFn: (ids: string[]) => deleteUnkownTransactionRequest(ids)
	});
}
